<template>
  <div class="industry_container">
    <a
      class="news_wrapper"
      v-for="item in newsList"
      :key="item.id"
      :href="item.href"
      target="_blank"
    >
      <div class="date">
        <div class="month">{{ item.date.monthDay }}</div>
        <div class="line"></div>
        <div class="year">{{ item.date.year }}</div>
      </div>
      <div class="pic" :style="{backgroundImage: `url('${item.url}')`}"></div>
      <div class="content_wrapper">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="content">
          {{ item.intro }}
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Industry',
  data () {
    return {
      list: [{
        id: '2019last',
        date: '2019-12-30',
        title: '2019版跨境电商进口正面清单重磅发布！看看都调整了什么？',
        intro: '经常买进口商品的亲们可能知道国家为了确保进口商品的质量,保护广大群众的消费安全,对跨境零售进口的商品实行负面清单+正面清单的管理方法',
        url: '/img/trends/1.jpg',
        href: 'https://mp.weixin.qq.com/s/3BU-tI4C5fos01Xj597Bvg'
      }, {
        id: '2020first',
        date: '2019-12-31',
        title: '2020年1月1日起，这些跨境电商相关政策即将实施',
        intro: '2019年已进入尾声，即将迎来2020年，跨境电商的小伙伴们，新的一年要注意什么？上海跨境公服汇总了2020年1月1日起实施或者刚实施不久的跨境电商相关政策。大家都需要了解哦！',
        url: '/img/trends/2.jpg',
        href: 'https://mp.weixin.qq.com/s/pi7G6SCMXRaZel_77lLjRg'
      }]
    }
  },
  methods: {
    uuid () {
      let s = []
      let hexDigits = '0123456789abcdef'
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4'
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
      s[8] = s[13] = s[18] = s[23] = '-'
      let uuid = s.join('')
      return uuid
    },
    formatDate (time) {
      let date = new Date(time)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      return {
        year,
        monthDay: (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
      }
    }
  },
  computed: {
    newsList: function () {
      const that = this
      return this.list.map((item) => {
        item.date = that.formatDate(item.date)
        return item
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.industry_container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .news_wrapper {
    height: 100px;
    display: flex;
    justify-content: flex-start;
    padding: 10px;
    color: #333;
    text-decoration: none;
    &:hover {
      cursor: pointer;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);;
    }
    .date {
      flex-shrink: 0;
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;
      border-radius: 3px;
      background-color: rgba(204, 204, 204, .45);
      color: #01a1eb;
      font-weight: 600;
      margin-right: 10px;
      .month {
        font-size: 32px;
      }
      .line {
        height: 2px;
        width: 80px;
        background-color: #d3d3d3;
      }
      .year {
        font-size: 30px;
      }
    }
    .pic {
      flex-shrink: 0;
      height: 100px;
      width: 150px;
      border: 1px solid #DDD;
      margin-right: 10px;
      background-image: url('/img/trends/code.png');
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .content_wrapper {
      max-width: 780px;
      flex-shrink: 1;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      box-sizing: border-box;
      padding: 5px 10px;
      border-radius: 3px;
      .title {
        font-size: 18px;
        overflow: hidden;
        text-align: justify;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        line-height: 20px;
        text-overflow: ellipsis;
      }
      .content {
        overflow: hidden;
        text-align: justify;
        font-size: 14px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        line-height: 20px;
      }
    }
  }
}
</style>
